import { useTranslations } from '@vocab/react';
import { Alert, Stack, Text } from 'braid-design-system';
import React from 'react';

import { PromptLayout } from 'src/components/PromptLayout';
import translations from 'src/locales.vocab';

import type { ErrorMessage } from './PreflightProvider';

interface PreflightErrorProps {
  error: ErrorMessage;
}

export const PreflightError = ({ error }: PreflightErrorProps) => {
  const { t } = useTranslations(translations);
  return (
    <PromptLayout>
      <Alert tone="critical">
        <Stack space="medium">
          <Text>{t('Sorry, we couldn’t prefill your application.')}</Text>

          <Text>{t(error)}</Text>
        </Stack>
      </Alert>
    </PromptLayout>
  );
};
